<template>
	<div class="compPinglun">
		<div class="pinglunNav">
			<div class="pinglunNavR">
				<div class="pinglunNavItem" @click="open_drawerAddPinglun('')">发表评论</div>
			</div>
			<div class="pinglunNavL">
				<div class="pinglunNavItem" :class="curNavIndex===0?'active':''" @click="changeCurNavIndex(0)">最新发布</div>
				<div class="pinglunNavItem" :class="curNavIndex===1?'active':''" @click="changeCurNavIndex(1)">最多点赞</div>
				<div class="pinglunNavItem" :class="curNavIndex===2?'active':''" @click="changeCurNavIndex(2)" style="border-right: 0;">最多回复</div>
			</div>
		</div>
		<div class="pinglunBox" v-if="tableData.length===0" style="padding-top: 20px;">
			暂无评论
		</div>
		<div class="pinglunBox" v-else>
			<div class="wordItem" v-for="(item,index) in tableData" :key="index">
				<div class="wordItemL">
					<img class="wordItemAvatar" :src="$public.getMemberPic(item.userId)"/>
				</div>
				<div class="wordItemR">
					<div class="wordMsgLine">
						<div class="wordPeople">{{item.userName}}</div>
						<div class="wordState">
							<span class="wordStateItem">回复 {{item.commentCount}}</span>
							<span class="wordStateItem">点赞 {{item.likeCount}}</span>
						</div>
					</div>
					<div class="wordContentLine">
						{{item.content}}
					</div>
					<div class="wordTimeLine">
						<!-- <div class="num1">15111111111</div> -->
						<div class="num2">{{item.release}}</div>
						<div class="btn" @click="set_pinglun(item)">设置数据</div>
						<!-- <div class="btn">下架评论</div> -->
						<div class="btn" @click="open_drawerAddPinglun(item.id)">回复</div>
						<div class="btn" @click="del_pinglun(item)">删除</div>
					</div>
					<!-- 子评论  👇  -->
					<div >
						<div class="wordItem" v-for="(itemChild,indexChild) in item.commnetList.slice(0, item.showChildCount)" :key="indexChild">
							<div class="wordItemL" style="width:28px;">
								<img class="wordItemAvatar" style="width:20px;height: 20px;" :src="$public.getMemberPic(itemChild.userId)"/>
							</div>
							<div class="wordItemR" style="border:0;">
								<div class="wordMsgLine">
									<div class="wordPeople">{{itemChild.userName}}</div>
									<div class="wordState">
										<!-- <span class="wordStateItem">回复 {{itemChild.commentCount}}</span> -->
										<span class="wordStateItem">点赞 {{itemChild.likeCount}}</span>
									</div>
								</div>
								<div class="wordContentLine">
									{{itemChild.content}}
								</div>
								<div class="wordTimeLine">
									<!-- <div class="num1">15111111111</div> -->
									<div class="num2">{{itemChild.release}}</div>
									<div class="btn" @click="set_pinglun(itemChild)">设置数据</div>
									<!-- <div class="btn">下架评论</div> -->
									<!-- <div class="btn">回复</div> -->
									<div class="btn" @click="del_pinglun(itemChild)">删除</div>
								</div>
							</div>
						</div>
					</div>
					<div  v-if="item.commnetList.length-item.showChildCount>0" class="wordMore" @click="item.showChildCount = item.showChildCount+10"> 
						— 展开更多{{(item.commnetList.length-item.showChildCount)}}条回复
					</div>
					<!-- 子评论  👆  -->
				</div>
			</div>
		</div>
		<div class="pagePosi">
			<page style="padding:10px 0;" :page="page.page" :total="page.total" @change="changePage"></page>
		</div>
		<div v-if="drawerAddPinglun_state">
			<drawerAddPinglun @submit="submit_drawerAddPinglun"></drawerAddPinglun>
		</div>
		<div v-if="drawerSetPinglun_state">
			<drawerSetPinglun :fatherId="curPinglun.fatherId" :commentCount="curPinglun.commentCount" :likeCount="curPinglun.likeCount" @submit="submit_drawerSetPinglun"></drawerSetPinglun>
		</div>
	</div>
</template>

<script>
	import page from "@/components/page.vue"
	import drawerAddPinglun from "@/components/pinglun/drawer_addPinglun.vue"
	import drawerSetPinglun from "@/components/pinglun/drawer_setPinglun.vue"
	export default {
		components:{page,drawerAddPinglun,drawerSetPinglun},
		data() {
			return {
				curNavIndex:0,
				
				// 列表
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				tableData:[],
				// 添加评论
				drawerAddPinglun_state:false,
				fatherId:'',
				// 设置评论
				drawerSetPinglun_state:false,
				curPinglun:{},
			}
		},
		computed:{
			
		},
		props:{
			contentId:{
				default:'',
			},
			contentType:{
				default:'',
			}
		},
		created(){
			
		},
		mounted(){
			this.getPinglunList();
		},
		methods:{
			// tab切换
			changeCurNavIndex(i){
				this.curNavIndex=i;
				this.page.page=1;
				this.getPinglunList()
			},
			// 获取评论
			changePage(num){
				this.page.page=num;
				this.getPinglunList()
			},
			getPinglunList(){
				let type = 0
				if(this.contentType==='商品'){ type=1 }
				else if(this.contentType==='活体'){ type=2 }
				else if(this.contentType==='文章'){ type=3 }
				else if(this.contentType==='动态'){ type=4 }
				else if(this.contentType==='评论'){ type=5 }
				else if(this.contentType==='口碑'){ type=6 }
				let sort = ''
				if(this.curNavIndex===1){sort="LikeCount"}
				else if(this.curNavIndex===2){sort="CommentCount"}
				let params = {
					"keyWord": "",
					"sort": sort, // 排序字段
					"desc": true, // 是否倒叙
					"type": type, // 1 商品 2 活体 3 文章 4 动态
					"paramId": this.contentId, // 评论对应的id
					"userId": "", // 用户id
					"state": 0, // 0 全部 1 已评论 2 审核通过 3 审核不通过
					"recommend": -1, // -1全部  0不热门 1热门
					"fatherId": "", // 父级评论
					"isStair": true, // 是否只取一级
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
				}
				// if(this.contentType===4){
				// 	params.paramId = this.contentId
				// }
				let loading = this.$loading()
				this.$http.post(process.env.VUE_APP_AppAdmin+'/api/UserComment/GetUserCommentList', params).then(res => {
					loading.close();
					if (res.code == 0) {
						this.page.total = res.data.count;
						let list = res.data.list
						this.tableData = [];
						for(let i=0;i<list.length;i++){
							list[i].showChildCount = 2
							this.tableData.push(list[i])
						}
					}
				})
			},
			// 添加评论
			open_drawerAddPinglun(str){
				this.fatherId = str
				this.drawerAddPinglun_state = true;
			},
			submit_drawerAddPinglun(obj){
				this.drawerAddPinglun_state = false;
				if(obj.type==='success'){
					let type = 0
					if(this.contentType==='商品'){ type=1 }
					else if(this.contentType==='活体'){ type=2 }
					else if(this.contentType==='文章'){ type=3 }
					else if(this.contentType==='动态'){ type=4 }
					else if(this.contentType==='评论'){ type=5 }
					else if(this.contentType==='口碑'){ type=6 }
					let params = {
						"type": type, //  0全部 1 商品 2 活体 3 文章 4 动态 5 提问答案
						"paramId": this.contentId, // 评论对应的id
						"content": obj.data.pinglunContent, 
						"fatherId": this.fatherId, // 父级评论
						"userId": obj.data.userId,
						"userName":obj.data.userName,
						// "recommend": 0, // -1全部  0不热门 1热门
						// "release": "",
						// "commentCount": 0, // 评论数量
						// "likeCount": 0, // 点赞数量
					}
					let loading = this.$loading()
					this.$http.post(process.env.VUE_APP_AppAdmin+'/api/UserComment/AddUserComment', params).then(res => {
						loading.close();
						if (res.code == 0) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.getPinglunList()
						}
					})
				}
			},
			// 删除评论
			del_pinglun(row){
				this.$confirm('确定删除该条评论?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let params = {
						id:row.id
					}
					let loading = this.$loading()
					this.$http.delete(process.env.VUE_APP_AppAdmin+'/api/UserComment/DeleteUserComment', params).then(res => {
						loading.close();
						if (res.code == 0) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.getPinglunList()
						}
					})
				})
			},
			// 设置评论
			set_pinglun(row){
				this.curPinglun = row;
				this.drawerSetPinglun_state = true;
			},
			submit_drawerSetPinglun(obj){
				this.drawerSetPinglun_state = false;
				if(obj.type==='success'){
					let params = {
						"id": this.curPinglun.id,
						"commentCount": parseInt(obj.data.commentCount),
						"likeCount": parseInt(obj.data.likeCount),
					}
					let loading = this.$loading()
					this.$http.post(process.env.VUE_APP_AppAdmin+'/api/UserComment/UpdateUserCommnetData', params).then(res => {
						loading.close();
						if (res.code == 0) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.getPinglunList()
						}
					})
				}
			},
		},
	}
</script>

<style lang="scss" scoped>
	.compPinglun{
		.pinglunNav{
			display: flex;justify-content:space-between;padding-top:20px;
			.pinglunNavL{
				display: flex;justify-content: flex-end;
				.pinglunNavItem{
					font-size: 14px;color:$color333;border-right: 1px solid #B0B0BF;padding:0 16px;font-weight: 600;cursor: pointer;
					&.active{
						color:#577BFF;
					}
				}
			}
			.pinglunNavR{
				.pinglunNavItem{
					background-color: #577BFF;padding: 6px 10px;color: #fff;border-radius: 4px;box-shadow: 2px 2px 5px #aaa;font-size: 14px;cursor: pointer;
				}
			}
		}
		.pinglunBox{
			border-radius: 8px;background-color: #F7F7FA;border:1px solid #F2F2F2;margin-top: 16px;padding:8px 32px 20px 32px;
			.wordItem{
				display: flex;padding-top:24px;
				.wordItemL{
					width:44px;flex-shrink: 0;
					.wordItemAvatar{
						width:36px;height: 36px;border-radius: 50%;
					}
				}
				.wordItemR{
					width:100%;border-bottom: 1px solid #D8D8D8;padding-bottom:24px;
					.wordMsgLine{
						display: flex;justify-content: space-between;padding: 2px 0 6px 0;
						.wordPeople{
							font-size: 14px;color:#666;
						}
						.wordState{
							display: flex;
							.wordStateItem{
								font-size: 14px;color:$color333;margin-left:32px;
							}
						}
					}
					.wordContentLine{
						font-size: 14px;color:#333;padding-right: 230px;line-height: 20px;
					}
					.wordTimeLine{
						display: flex;padding-top:16px;
						.num1{
							font-size: 14px;color:#333;margin-right: 16px;
						}
						.num2{
							font-size: 14px;color:$color999;margin-right: 32px;
						}
						.btn{
							font-size: 14px;color:#577BFF;margin-right: 32px;cursor: pointer;
						}
					}
				}
				.wordMore{
					font-size: 14px;color:#999999;cursor: pointer;padding: 10px 0 0 0;
				}
			}
		}
		.pagePosi{
			text-align: right;
		}
		// 添加评论
		.drawer_pinglun{
			.drawer_addPinglun{
				.pinglunInput{
					width:550px;
				}
				.pinglunBtn{
					background: linear-gradient(135deg, #5685FF 0%, #3569FF 100%);border-radius: 8px;line-height: 44px;margin:50px 16px 30px;text-align: center;color:#fff;font-size: 14px;cursor: pointer;
				}
			}
		}
	}
</style>